/*
 * Copyright (c) 2024. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

/**
 * `true` when running inside a Tauri WebView (desktop or iOS shell). Detected
 * by the `__TAURI_INTERNALS__` global Tauri injects into every webview before
 * any app code runs.
 */
export const IS_TAURI = '__TAURI_INTERNALS__' in globalThis

/**
 * `true` on Safari user agents. The regex excludes Chrome and the Chrome/Firefox
 * iOS variants (crios/fxios) which also carry "Safari" in their UA string.
 */
export const isSafari =
    typeof navigator !== 'undefined' &&
    /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent)
